import { mq } from '@kvdbil/components';
import { CSSProperties } from 'react';
import styled from 'styled-components';

export const Form = styled.form.attrs({ noValidate: true })`
  &:after,
  &:before {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }
  width: calc(100% + 0.75rem);
  margin-top: 0.75rem * -1;
  margin-right: 0.75rem * -1;

  ${mq('tablet')} {
    width: calc(100% + 1rem);
    margin-top: 1rem * -1;
    margin-right: 1rem * -1;
  }
`;

export const FormItem = styled.div<{ textAlign?: CSSProperties['textAlign'] }>`
  margin-top: 0.75rem;
  margin-right: 0.75rem;

  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};

  ${mq('tablet')} {
    margin-top: 1rem;
    margin-right: 1rem;
  }
`;
